// extracted by mini-css-extract-plugin
export var downArrow = "_7k-0";
export var label = "_7k-1";
export var treatmentCard = "_7k-3";
export var upArrow = "_7k-2";